jQuery(document).ready(function () {
    ///
    var CustomersSwiper = new Swiper(".customers_swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
        nextEl: ".customers_button_next",
        prevEl: ".customers_button_prev",
    },
    pagination: {
        el: ".customers_pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 3,
        },

    },
    });
});

// function applyJudgeMeSort() {
//     var $dd = jQuery('.jdgm-sort-dropdown-wrapper select.jdgm-sort-dropdown');

//     if ($dd.length) { 
//         // console.log('welcome');
//         $dd.val('highest-rating');  
//         $dd[0].dispatchEvent(new Event('change', { bubbles: true }));
//         return true;
//     }

//     return false;
// }

// // Try multiple times until Judge.me creates the dropdown
// var interval = setInterval(function () {
//     if (applyJudgeMeSort()) {
//         // console.log('welcome - 123');
//         clearInterval(interval);
//     }
// }, 300);

// Disable judge.me auto scroll
// window.addEventListener("jdgm/scroll-to-widget", function (e) {
//     e.stopImmediatePropagation();
// }, true);

// var tryCount = 0;
// var sortInterval = setInterval(function () {
//     tryCount++;

//     var $dd = jQuery('.jdgm-sort-dropdown');
//     if ($dd.length) {
//         $dd.val('highest-rating')[0].dispatchEvent(new Event('change', { bubbles: true }));
//         clearInterval(sortInterval);   // 🔥 STOP LOOP → scrolling will not freeze
//     }

//     if (tryCount > 10) {
//         clearInterval(sortInterval);   // Safety → stop after 10 tries
//     }
// }, 300);

//jQuery(document).on("jdgm/reviews-loaded", function () {

    // 1. Disable Judge.me automatic scroll
   

    // 2. Apply sorting safely
    // const $dd = jQuery('.jdgm-sort-dropdown');

    // if ($dd.length) { console.log('wel');
    //     $dd.val('highest-rating');
    //     $dd[0].dispatchEvent(new Event("change", { bubbles: true }));
    // }
//     var tryCount = 0;
//     var sortInterval = setInterval(function () {
//         tryCount++;
// console.log('wel');
//         var $dd = jQuery('.jdgm-sort-dropdown');
//         if ($dd.length) {
//              window.jdgmAutoScroll = false;
//             console.log('wel123');
//             $dd.val('highest-rating')[0].dispatchEvent(new Event('change', { bubbles: true }));
//             clearInterval(sortInterval);   // 🔥 STOP LOOP → scrolling will not freeze
//         }

//         if (tryCount > 10) {
//             clearInterval(sortInterval);   // Safety → stop after 10 tries
//         }
//     }, 300);
//});

// Apply sorting safely
// document.addEventListener("jdgm/reviews-loaded", function () {
//     var $dd = jQuery('.jdgm-sort-dropdown');
//     if ($dd.length) {
//         $dd.val('highest-rating')[0].dispatchEvent(new Event('change', { bubbles: true }));
//     }
// });

jQuery(document).on("jdgm/reviews-loaded", function () {

    // apply sorting
    var $dd = jQuery('.jdgm-sort-dropdown');
    if ($dd.length) {
        $dd.val('highest-rating')[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    // scroll to reviews section
    jQuery('html, body').animate({
        scrollTop: jQuery('#judgeme_product_reviews').offset().top
    }, 600);

});

 jQuery(document).ready(function($){
    var $grid = $('#blogGrid');
    var $cards = $grid.find('.blog-card');
    $cards.sort(function(a, b){
        return parseInt($(b).attr('data-date')) - parseInt($(a).attr('data-date'));
    });
    $grid.append($cards);
});
 

jQuery('.banner-cursor-point').click(function(){
    var url = jQuery(this).attr('data-url');
    window.location.href=url;
}); 
